import { useEffect, useState } from "react";
import "./ScheduleView.scss";
import { useDispatch, useSelector } from "react-redux";
import { getTimeEpochToUTC } from "../Utils/HelperFunctions";
import { ReactComponent as CurrentScheduleIcon } from "../../assets/raw/GenerateSchedule.svg";
import {
  EmptyListIcon,
  ScheduleGroundAssignIcon,
  ScheduleOrderAssignIcon,
  SortColumnIcon,
  StatusActive,
  StatusCaptureComplete,
  StatusDownlinkComplete,
  StatusNew,
} from "../../assets/icons/Icons";
import {
  setShowReviewSchedulePopup,
  setShowGenerateScheduleConfig,
} from "../../../../store/UnifiedControlPlaneSlice";
import { CircularProgress } from "@mui/material";
import CustomToolTip from "../../../CommonComponents/CustomToolTip";
import CustomFilter from "../../../CommonComponents/custom_filter/CustomFilter";

export const getStatusDetails = (state, type) => {
  let statusDetails = null;
  switch (state) {
    case "active":
      statusDetails = type === 'Icon' ? <StatusActive /> : 'Capture In-progress'
      break;
    case "CaptureComplete":
      statusDetails = type === 'Icon' ? <StatusCaptureComplete /> : 'Capture Complete'
      break;
    case "DownlinkComplete":
      statusDetails = type === 'Icon' ? <StatusDownlinkComplete /> : 'Downlink Complete'
      break;
    case "New":
    case "waiting":
      statusDetails = type === 'Icon' ? <StatusNew /> : 'Capture Pending'
      break;
    default:
      statusDetails = type === 'Icon' ? <StatusActive /> : 'Capture'
      break;
  };
  return statusDetails
}

export const getPriorityIcon = (status) => {
  let priorityIcon = "";
  switch (status) {
    case "ASAP":
      priorityIcon = require("../../assets/raw/Asap.svg").default;
      break;
    case "High":
      priorityIcon = require("../../assets/raw/High.svg").default;
      break;
    case "Normal":
      priorityIcon = require("../../assets/raw/Normal.svg").default;
      break;
    default:
      priorityIcon = require("../../assets/raw/Asap.svg").default;
      break;
  }
  return priorityIcon;
};

export const getListOfOrders = (orders) => {
  return (
    <>
      {orders &&
        orders.length > 0 &&
        orders.map((order, index) => (
          <span key={order.orderId}>
            <img
              className="order_details_spacing"
              src={getPriorityIcon(order?.priorityLane)}
              alt=""
            />
            {order.orderName}
            {index < orders.length - 1 ? ", " : ""}
          </span>
        ))}
    </>
  );
};

const CurrentScheduleView = () => {
  const dispatch = useDispatch();
  const fetchingOrderAssignments = useSelector(
    (state) => state.unifiedControlPlane.fetchingOrderAssignments
  );
  const currentScheduleData = useSelector(
    (state) => state.unifiedControlPlane.currentScheduleData
  );
  const orderAssignments = useSelector(
    (state) => state.unifiedControlPlane.orderAssignments
  );
  const orders = useSelector((state) => state.unifiedControlPlane.orders);

  const [data, setData] = useState([]);


  const [allFilters, setAllFilters] = useState({
    advanceFilters: [
      {
        operator: '',
        properties: '',
        value: '',
      },
    ],
    searchFilter: '',
  });

  useEffect(() => {
    if (orderAssignments && Array.isArray(orderAssignments)) {
      setData(orderAssignments);
    }
  }, [orderAssignments]);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedData = [...data].sort((a, b) => {
      const aValue = getNestedValue(a, key);
      const bValue = getNestedValue(b, key);

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setData(sortedData);
    setSortConfig({ key, direction });
  };

  const [showSearchPopup, setShowSearchPopup] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const togglePopup = () => setShowSearchPopup((prev) => !prev);
  //const searchInputRef = useRef(null);

  // const saveSearchTerm = () => {
  //   setSearchTerm(searchInputRef.current.value);
  // };

  const SearchPopup = () => (
    <div className="search-popup">
      <div className="search-popup-content">
        <input
          type="text"
          placeholder="Search by Order Name"
          // defaultValue={searchTerm}
          // ref={searchInputRef}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-popup-input"
          autoFocus
        />
        {/* <button onClick={saveSearchTerm}>Search</button> */}
        <div className="current-schedule-close-action" onClick={togglePopup}>
          <img
            className="CloseIcon"
            src={require("../../assets/raw/CloseIconWhite.svg").default}
            alt="close-icon"
          />
        </div>
      </div>
    </div>
  );

  const filteredData = searchTerm
    ? data.filter((row) => {
      const orderName = row?.data?.orderSummary?.orderName;
      return orderName?.toLowerCase().includes(searchTerm?.toLowerCase());
    })
    : data;

  const handleSearchFilter = (filters) => {
    setSearchTerm(filters.searchFilter);
  }
  const closeScheduleReview = () => {
    setSearchTerm("");
    setShowSearchPopup(false);
    dispatch(setShowReviewSchedulePopup(""));
  };

  const handleClickGenerate = () => {
    closeScheduleReview();
    dispatch(setShowGenerateScheduleConfig(true));
  };

  return (
    <div className={`current-schedule ${fetchingOrderAssignments ? "loading-schedule" : ""}`}>
      {showSearchPopup && <SearchPopup />}
      <div className="current-schedule-header">
        <div className="current-schedule-title">
          <div className="current-schedule-title-icon">
            <CurrentScheduleIcon />
          </div>
          <p className="current-schedule-title-text">Active Schedule</p>
          {currentScheduleData?.scheduleSummary?.scheduledOrdersCount
            && <div className="current-schedule-title-sub-text">{currentScheduleData?.scheduleSummary?.scheduledOrdersCount}<span>/</span>{(orders?.executed?.length || 0) + (orders?.current?.length || 0) + (orders?.pending?.length || 0)}</div>
          }
        </div>
        <div className="current-schedule-orders-summary">
          <div
            className="current-schedule-close-action"
            onClick={closeScheduleReview}
          >
            <img
              className="CloseIcon"
              src={require("../../assets/raw/CloseIconWhite.svg").default}
              alt="close-icon"
            />
          </div>
        </div>
      </div>
      {fetchingOrderAssignments ? (
        <div className="loading-schedule-msg">
          <CircularProgress color="inherit" />
        </div>
      ) : orderAssignments && orderAssignments.length > 0 ? (
        <div className="schedule-table-section">
          <div className="schedule_list_filter_section">
            <CustomFilter
              alignment="right"
              search={{
                applyFilter: (filters) => {
                  handleSearchFilter(filters);
                }
              }}
              allFilters={allFilters}
              setAllFilters={setAllFilters}
              filterCase={'ucp'}
              boundingScreen={'list-schedule'}
            />
          </div>
          <table className="schedule-table">
            <thead className="schedule-table-header">
              <tr className="schedule-table-row">
                <th className="schedule-table-column-width"></th>
                <th className="schedule-table-column-width">
                  <span>
                    Assignment
                  </span>
                  <span
                    className="table-sort"
                    onClick={() => handleSort("label")}
                  >
                    <SortColumnIcon />
                  </span>
                </th>

                <th className="schedule-table-column-width">
                  <span>
                    Order Details
                  </span>
                  {/* <button
                          className="table-sort"
                          onClick={() => handleSort("data.orderName")}>
                          <img className="sort-col" src={require("../../assets/raw/SortIcon.svg").default} />
                      </button> */}
                  {/* <button
                          className="table-sort"
                          onClick={togglePopup}>
                          <img className="filter-col" src={require("../../assets/raw/FilterIconWhite.svg").default} />
                      </button> */}
                </th>
                <th className="schedule-table-column-width">
                  <span>Time</span>
                  <div
                    className="table-sort"

                    onClick={() => handleSort("startEpochSec")}
                  >
                    <SortColumnIcon />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="schedule-table-content">
              {filteredData.map((row, index) => (
                <tr key={index} className="schedule-table-row">
                  <td className="schedule-table-column-width">
                    <CustomToolTip title={getStatusDetails(row?.state, 'Text')}>
                      <div
                        className={`status-icon ${row?.state === "active" ? "rotate-icon" : ""}`}
                      >
                        {getStatusDetails(row?.state, 'Icon')}
                      </div>
                    </CustomToolTip>
                  </td>
                  <td className="schedule-table-column schedule-table-column-width assignment-column">
                    <div className="assignment-icon">
                      {row?.type === "Order" ? (
                        <ScheduleOrderAssignIcon />
                      ) : (
                        <ScheduleGroundAssignIcon />
                      )}
                    </div>
                    {row?.type === "Order" ? (
                      <div>
                        <span className="satellite-name">
                          {row?.data?.satellite?.name}
                        </span>
                      </div>
                    ) : (
                      <div className="assignment-group">
                        <span className="satellite-name">
                          {row?.data?.satellite?.name}
                        </span>
                        <span className="ground-station-name">
                          {row?.data?.groundStation?.name}
                        </span>
                      </div>
                    )}
                  </td>
                  <td className="schedule-table-column schedule-table-column-width">
                    {row?.type === "Order" ? (
                      <span>
                        <img
                          className="order_details_spacing"
                          src={getPriorityIcon(
                            row?.data?.orderSummary?.priorityLane
                          )}
                          alt="order-details-spacing"
                        />
                        {row?.data?.orderSummary?.orderName
                          ? row?.data?.orderSummary?.orderName
                          : "-"}
                      </span>
                    ) : (
                      <div className="orders-wrapper">
                        <CustomToolTip title={getListOfOrders(row?.data?.downlinkOrders)}>
                          <span className="orders_text">
                            <span className="order_details_spacing">
                              {row?.data?.downlinkOrders
                                ? row?.data?.downlinkOrders.length > 1 ? row?.data?.downlinkOrders.length : getListOfOrders(row?.data?.downlinkOrders)
                                : "All"}
                            </span>
                            {row?.data?.downlinkOrders.length > 1 ? 'Orders' : ''}
                          </span>
                        </CustomToolTip>
                      </div>
                    )}
                  </td>
                  <td className="time-column schedule-table-column-width">
                    {getTimeEpochToUTC(row?.startEpochSec)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="empty-schedule-container">
          <EmptyListIcon />
          <div className="empty-schedule-text-container">
            <div className="empty-schedule-text-style empty-schedule-text">
              No Active Schedule
            </div>
            <div className="empty-schedule-text-style empty-schedule-subtext">
              Genereate a new schedule
            </div>
            <div></div>
          </div>
          <button
            className="generate-schedule-button"
            onClick={handleClickGenerate}
          >
            <span className="generate-schedule-button-text">Generate</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default CurrentScheduleView;
